import React, {memo, Suspense} from "react"
import {useTemplatedComponent} from "@next/templating"
import {formatTextTestIds} from "@next/utils"
import {MANIFEST} from "@manifest/header"
import {Item} from "../../models/shoppingbag"
import {ItemWrapper, BannerWrapper} from "./component"
import ProductImage from "../ProductImage"
import MiniShoppingBagBanner from "../MiniShoppingBagBanner"
import connect from "./connect"
import {SOFA_CATEGORY} from "../../config/constants"

export type MiniShoppingBagItemProps = {
    item: Item
    text: any
    gridItemInfo?: boolean
    templating: {
        mainTemplate: string
        fallbackTemplate: string
    }
    saleName: string
    realm: string
    showItemDescription: boolean
    showProductName: boolean
    threeFourImageryEnabled: boolean
}

export const MiniShoppingBagItem = memo(
    ({
        item: {
            CistStoreName,
            ItemID,
            itemImageUrl,
            Description,
            AlternativeDescription,
            PriceFormatted,
            SizeDescription,
            Quantity,
            StockMessage,
            StockStatus,
            Url,
            IsDiscount,
            ItemNumber,
            ProductName,
            TPSearchDescription,
            MiniBagItemBannerMessage,
            ItemCategory,
            Personalisation,
        },
        text,
        templating,
        saleName,
        realm,
        showItemDescription,
        showProductName,
        threeFourImageryEnabled,
    }: MiniShoppingBagItemProps) => {
        const {at} = text
        const ciStoreName = CistStoreName ? `${at} ${CistStoreName}` : ""

        const ComponentName = useTemplatedComponent(templating, MANIFEST)
        const showMessage = MiniBagItemBannerMessage && MiniBagItemBannerMessage.trim() !== ""
        const showThreeFourImage = ItemCategory !== SOFA_CATEGORY && Personalisation !== "Y"
        return (
            <ItemWrapper key={ItemID} data-testid={formatTextTestIds(`header-mini-shopping-bag-item-id-${ItemID}`)}>
                <ProductImage
                    itemImageUrl={itemImageUrl}
                    url={Url}
                    description={Description}
                    itemNumber={ItemNumber}
                    threeFourImageryEnabled={threeFourImageryEnabled && showThreeFourImage}
                />
                <Suspense>
                    <ComponentName
                        ProductName={ProductName}
                        IsDiscount={IsDiscount}
                        StockStatus={StockStatus}
                        StockMessage={StockMessage}
                        Quantity={Quantity}
                        SizeDescription={SizeDescription}
                        Description={Description}
                        PriceFormatted={PriceFormatted}
                        AlternativeDescription={AlternativeDescription}
                        text={text}
                        url={Url}
                        TPSearchDescription={TPSearchDescription}
                        ciStoreName={ciStoreName}
                        saleName={saleName}
                        showItemDescription={showItemDescription}
                        showProductName={showProductName}
                    />
                </Suspense>
                {showMessage && (
                    <BannerWrapper>
                        <MiniShoppingBagBanner message={MiniBagItemBannerMessage} realm={realm} />
                    </BannerWrapper>
                )}
            </ItemWrapper>
        )
    },
)
MiniShoppingBagItem.displayName = "MiniShoppingBagItem"

export default connect(MiniShoppingBagItem)
